module.exports = __webpack_public_path__ + "static/media/kopilaCrying.5cebe3ce.ogg";